import { useVoiceAssistant } from '@livekit/components-react';
import type { AgentState } from '@livekit/components-react';

import { useOralExamLabOverrides } from '@/common/oralExam/oralExamLabOverrides';

/**
 * True when the LiveKit voice-assistant agent is present in the current room
 * (not merely that the student's own transport is Connected).
 *
 * Must only be called under a LiveKit room provider.
 */
export function isExaminerAgentPresentState(state?: AgentState | null, agent?: unknown): boolean {
  if (!agent) return false;
  if (state == null || state === 'disconnected') return false;
  return true;
}

export function useExaminerAgentPresent(): boolean {
  const lab = useOralExamLabOverrides();
  const { agent, state } = useVoiceAssistant();
  if (typeof lab?.examinerPresent === 'boolean') {
    return lab.examinerPresent;
  }
  return isExaminerAgentPresentState(state, agent);
}

/** Transport healthy AND AI examiner participant present. */
export function resolveExamConnectedIndicator(
  isReconnecting: boolean,
  examinerPresent: boolean,
): boolean {
  return !isReconnecting && examinerPresent;
}
